module.exports = __webpack_public_path__ + "img/neosurf.470d8ec7.svg";